import React from "react";
import { IconButton, InputAdornment, Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Visibility, VisibilityOff } from "@mui/icons-material";

import { colors } from "theme";

const useStyles = makeStyles((theme: Theme) => ({
  visibleBtn: {
    marginRight: -12,
    color: colors.grey[300],
  },
}));

const PasswordToggleIcon = ({
  visible,
  setVisible,
}: {
  visible: boolean;
  setVisible: Function;
}) => {
  const classes = useStyles();

  return (
    <InputAdornment position="end">
      <IconButton
        className={classes.visibleBtn}
        onClick={() => setVisible(!visible)}
        onMouseDown={(event: React.MouseEvent<HTMLButtonElement>) =>
          event.preventDefault()
        }
        size="large">
        {visible ? <Visibility /> : <VisibilityOff />}
      </IconButton>
    </InputAdornment>
  );
};

export default PasswordToggleIcon;
